import { render, staticRenderFns } from "./ClientAddress.vue?vue&type=template&id=06ba86b1&scoped=true"
import script from "./ClientAddress.vue?vue&type=script&lang=js"
export * from "./ClientAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ba86b1",
  null
  
)

export default component.exports